import { Component } from '@angular/core';

@Component({
    selector: 'loading-screen-component',
    templateUrl: './loading-screen.component.html',
})
export class LoadingScreenComponent{

}